const { debounce } = window.BAO.Utils

class CartItem extends window.BAO.CustomElement() {
  constructor () {
    super()

    this._loading = false
    this.sections = this.inPushCart
      ? window.BAO.sectionRenderer.pushCartSections
      : this.onCartPage
        ? window.BAO.sectionRenderer.cartSections
        : []
  }

  setupListeners () {
    super.setupListeners()

    this.changeLineItem = this.changeLineItem.bind(this)
    this.removeLineItem = this.removeLineItem.bind(this)
    this.onQuantityChange = this.onQuantityChange.bind(this)
    this.removeWishlistLineItem = this.removeWishlistLineItem.bind(this)

    this.debouncedOnQuantityChange = debounce(event => {
      this.onQuantityChange(event)
    }, 500)

    this.listeners.add(
      this,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.debouncedOnQuantityChange,
    )

    if (this.els?.remove?.exists) {
      this.listeners.add(this.els.remove.element, 'click', this.removeLineItem)
    }

    if (this.els?.variant && this.els?.variant.exists) {
      this.listeners.add(
        this.els.variant.element,
        'change',
        this.changeLineItem,
      )
    }

    if (this.els?.wishlist?.exists) {
      this.listeners.add(
        this.els.wishlist.element,
        'click',
        this.removeWishlistLineItem,
      )
    }
  }

  async removeLineItem (e) {
    e?.preventDefault()

    this.loading = true

    const state = await window.BAO.Cart.removeItem(this.dataset.key, {
      sections: this.mappedSections,
    })

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)

    window.BAO.UpdatePushCartLoyalty.init()
  }

  async changeLineItem (event) {
    this.loading = true

    const id = event.target.value

    let properties = null
    const preOrderKey = window?.theme?.strings?.estimated_dispatch
    const preOrderProperty =
      event?.target?.options[event?.target?.selectedIndex]?.dataset?.preorder
    if (preOrderProperty !== undefined) {
      properties = { [preOrderKey]: preOrderProperty, _preorder: true }
    }

    let quantity = 1
    const maxQuantity =
      event?.target?.options[event?.target?.selectedIndex]?.dataset
        ?.maxInventory ?? 1
    const currentQuantity = event?.target?.dataset?.currentQuantity ?? 1
    quantity = Math.min(currentQuantity, maxQuantity)

    await this.removeLineItem()
    const state = await window.BAO.Cart.addItem(
      { id, quantity, properties },
      {
        sections: this.mappedSections,
      },
    )

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)

    window.BAO.UpdatePushCartLoyalty.init()
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  async removeWishlistLineItem (e) {
    e.preventDefault()

    if (e.currentTarget.classList.contains('iwishAdded')) return

    this.loading = true

    const state = await window.BAO.Cart.removeItem(
      this.dataset.id,
      this.dataset.key,
      {
        sections: this.mappedSections,
      },
    )

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)

    if (typeof Storage !== 'undefined') {
      document
        .querySelectorAll('[data-i-wishlist-external-el="count"]')
        .forEach(countEl => {
          const count =
            typeof localStorage.iWishCnt !== 'undefined'
              ? localStorage.iWishCnt
              : ''
          countEl.dataset.count = count
          countEl.innerHTML = count
        })
    }
  }

  async onQuantityChange (e) {
    this.loading = true

    if (e.detail.value === 0) {
      this.removeLineItem(e)

      this.loading = false
    } else {
      const state = await window.BAO.Cart.updateQuantity(
        this.dataset.key,
        e.detail.value,
        { sections: this.mappedSections },
      )

      this.loading = false
      if ('sections' in state) this.renderSections(state.sections)
    }

    window.BAO.UpdatePushCartLoyalty.init()
  }

  get mappedSections () {
    return this.sections.map(s => s.section)
  }

  get loading () {
    return this._loading
  }

  set loading (val) {
    this._loading = val

    if (this.inPushCart) {
      this.pushCart.loading = val
    }

    this.setAttribute('aria-busy', val.toString())
  }

  get pushCart () {
    return this.closest('push-cart')
  }

  get inPushCart () {
    return this.pushCart != null
  }

  get cart () {
    return this.closest('cart-items')
  }

  get onCartPage () {
    return this.cart != null
  }
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', CartItem)
}
